import React from 'react';
import InputMask from 'react-input-mask';

export const MaskedInputPhone = ({ onChange, ...rest }) => {
    return (
      <InputMask
        className="rs-input"
        {...rest}
        mask="(999) 999 9999" 
        maskChar={null}
        onChange={event => {
          onChange(event.target.value);
        }}
      />
    );
  };

  export const MaskedInputYear = ({ onChange, ...rest }) => {
    return (
      <InputMask
        {...rest}
        className="rs-input"
        mask="2099" 
        maskChar={null}
        onChange={event => {
          onChange(event.target.value);
        }}
      />
    );
  };

  export const MaskedInput = ({ onChange, ...rest }) => {
    return (
      <InputMask
        {...rest}
        className="rs-input"
        maskChar={null}
        onChange={event => {
          onChange(event.target.value);
        }}
      />
    );
  };